import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { bootTrace, describeError } from 'app/shared/diagnostics/boot-trace';
// import { ExceptionTypeEnum } from '@ordersnproducts/modules/shared/models/exception-type.enum';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: Error | HttpErrorResponse) {
    // appInsights.trackException(error);
    // appInsights.trackTrace(ExceptionTypeEnum.JS, { name: error.name, message: error.message });

    // TEMP (DCM001CMG01-17401): mirror the error into the HAR — the frozen-screen
    // reports only ever come back as HAR captures, where console output is lost.
    bootTrace('err:angular', describeError(error));

    console.error(error);
  }
}
